import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './routes/ProtectedRoute';
import Login from './pages/Login/Login';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import Products from './pages/Products/Products';
import Resellers from './pages/Resellers/Resellers';
import Reports from './pages/Reports/Reports';
import Users from './pages/Users/Users';
import Alerts from './pages/Alerts/Alerts';
import SystemStatus from './pages/SystemStatus/SystemStatus';
import Profile from './pages/Profile/Profile';
import { DemoNotice } from './components/ui/DemoNotice';

export default function App() {
  return (
    <>
    {/* Demo build: explains any refused write. Renders nothing when idle. */}
    <DemoNotice />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
      <Route path="/resellers" element={<ProtectedRoute><Resellers /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />
      <Route path="/alerts" element={<ProtectedRoute adminOnly><Alerts /></ProtectedRoute>} />
      <Route path="/system-status" element={<ProtectedRoute adminOnly><SystemStatus /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
    </Routes>
    </>
  );
}
